var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"gray","margin-top":"-128px","height":"128px"}},[_c('iframe',{key:_vm.url,staticClass:"iframe",attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }